import { createHttpService } from '../../../http-service/http-service-factory';
import { SSOHttpServiceConfigurator } from '../../sso-http-service-configurator';
import { ZITADEL_BASE_URL } from './const';

export const zitadelHttpService = createHttpService(
  new SSOHttpServiceConfigurator(ZITADEL_BASE_URL)
);